// extracted by mini-css-extract-plugin
module.exports = {"splitter":"e_J"};